import React from "react"
import * as signalR from "@microsoft/signalr"
import { quadriProjectIdState } from "./StateSelectors"
import { useRecoilValue } from "recoil"
import GetEnvironment from "../enviroments"

export interface SignalrClientProps {
  children: React.ReactNode
}

export const SignalrClient = (props: SignalrClientProps) => {
  const quadriProjectId = useRecoilValue(quadriProjectIdState)

  // Initialize signalr client when project ID changes (will only initialize if project id is present)
  React.useEffect(() => {
    console.log("Running effect: ", quadriProjectId)
    console.log("onReceive", onReceiveMessage)
    initSignalrClient({
      projectId: quadriProjectId,
      onReceiveMessage
    })
  }, [quadriProjectId])

  return <>{props.children}</>
}

const getConnection = () => {
  const signalrBaseUrl = GetEnvironment().signalrBaseUrl
  if (!signalrBaseUrl) {
    console.warn("No signalrBase URL, real time events will not be processed")
  }

  return signalrBaseUrl
    ? (() => {
        console.log("Constructing signalr hub connection")
        return new signalR.HubConnectionBuilder()
          .withUrl(`${signalrBaseUrl}/quadrihub`, {
            accessTokenFactory: () => localStorage.getItem("tc-access-token") as string
          })
          .build()
      })()
    : undefined
}

const initSignalrClient = (props: { projectId?: string; onReceiveMessage: (topic: string, message: any) => void }) => {
  let connection = getConnection()
  if (props.projectId && connection) {
    connection.on("ReceiveMessage", props.onReceiveMessage)
    connection
      .start()
      // .then(() => {
      //   console.log("waiting 30 sec to resolve...")
      //   return new Promise((resolve) => setTimeout(resolve, 30000))
      // })
      .then(() => {
        connection!
          .invoke("JoinProjectUpdates", props.projectId)
          .catch((err) => {
            return console.error(err.toString())
          })
          .then(() => {
            console.log("Initialized signalr client with project id: ", props.projectId)
          })
      })
      .catch((err) => {
        return console.error(err.toString())
      })
  }
}

const onReceiveMessage = (topic: string, message: any) => {
  console.log("Received signalr message, topic ", topic, ", message", message)
  switch (topic) {
    // Whenever a topic is received, reload the whole extension. This means that
    // if the operation was successful, then it will show updated state. If it was
    // not, then the error state is fetched from TCPS.
    case "ddm-tcps-delete-project-result-topic":
      window.location.reload()
      break
    case "ddm-tcps-change-project-result-topic":
      window.location.reload()
      break
    case "ddm-tcps-new-project-result-topic":
      window.location.reload()
      break
  }
}
